<template>
  <div v-if="hasFilterData">
    <div class="row">
      <div v-if="availableYears.length > 0" class="col-lg-3 col-md-6 col-sm-6">
        <label>{{this.$t('dokumentet.filtro')}}</label>
        <div>
          <select
            v-model="filters.selectYear"
            @change="fetchDocuments"
            class="form-select"
           :placeholder="$t('dokumentet.zgjedhvitin')"
          >
            <option value="">{{this.$t('dokumentet.showall')}}</option>
            <option v-for="year in availableYears" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
        <div v-if="filters.selectYear === '' && availableYears.length > 0" class="mt-2 text-muted" style="font-size: 0.95em;">
          <span>{{ minYear }} - {{ maxYear }}</span>
        </div>
      </div>
      <div v-if="filteredCategoryOptions.length > 0" class="col-lg-3 col-md-6 col-sm-6">
        <label>{{this.$t('dokumentet.lloji')}}</label>
        <Treeselect
          v-model="filters.CategoriesIds"
          :multiple="true"
          :options="filteredCategoryOptions"
          placeholder="Choose Option"
        />
      </div>
      <div
        v-if="filters.CategoriesIds.includes(14) && filteredSubCategoryOptions.length > 0"
        class="col-lg-3 col-md-6 col-sm-6"
      >
        <label>Sub Kategorias:</label>
        <Treeselect
          v-model="filters.SubCategoriesIds"
          :multiple="true"
          :options="filteredSubCategoryOptions"
          placeholder="Choose Option"
        />
      </div>
      <!-- Uncomment and add conditional rendering for institutions if needed -->
      <!-- <div v-if="postCategoriesIds.length > 0" class="col-lg-3 col-md-6 col-sm-6">
        <label>Institucioni:</label>
        <Treeselect
          v-model="filters.PostCategoriesIds"
          :options="postCategoriesIds"
          :multiple="true"
          placeholder="Zgjedh Institucionin..."
        />
      </div> -->
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <br />
        <button
          type="submit"
          @click="fetchDocuments"
          class="btn btn-secondary btn-block"
        >
          {{this.$t('dokumentet.search')}} <i class="bi bi-search"></i>
        </button>
      </div>
    </div>
  </div>
  <div v-else class="alert alert-info">
    No filters available.
  </div>
</template>


<script>
import Treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import axios from "axios";
import { useRoute } from "vue-router";
import { useDocumentStore } from "@/store/DocumentStore/documentStore";

import i18n from "@/locales/i18n";

export default {
  components: { Treeselect },
  props: {
    modelValue: Object,
    documentTypeId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  emits: ["update:modelValue", "apply-filters", "update:availableYears"],
  setup() {
    const route = useRoute();
    return { route };
  },    
  data() {
    const documentTypeId = this.route.query.documentTypeId || "default";
    return {
     API_URL: "https://prokuroriaapi.cmdsoftwares.com/api/v1/dashboard/group-type/separate/",
    //  API_URL: "https://localhost:7131/api/v1/dashboard/group-type/separate/",
      documentCategoryURL: `documetCategory/${documentTypeId}/${i18n.global.locale || "AL"}`,
      documentSubCategoryURL: `documetsubcategory/${documentTypeId}/${i18n.global.locale || "AL"}`,
      documentPostCatgoryUrl: `documetpostcategory/${documentTypeId}/${i18n.global.locale || "AL"}`,
      filteredCategoryOptions: [],
      postCategoriesIds: [],
      filteredSubCategoryOptions: [],
      availableYears: [],
      documentStore: null,
    };
  },
  computed: {
    filters: {
      get() {
        return (
          this.modelValue || {
            CategoriesIds: [],
            SubCategoriesIds: [],
            PostCategoriesIds: [],
            selectYear: null,
          }
        );
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    // Check if any filter data is available
    hasFilterData() {
      return (
        this.availableYears.length > 0 ||
        this.filteredCategoryOptions.length > 0 ||
        this.filteredSubCategoryOptions.length > 0 ||
        this.postCategoriesIds.length > 0
      );
    },
    minYear() {
      return this.availableYears.length ? Math.min(...this.availableYears) : '';
    },
    maxYear() {
      return this.availableYears.length ? Math.max(...this.availableYears) : '';
    },
  },
  watch: {
    "filters.CategoriesIds": function (newVal) {
      if (!newVal.includes(14)) {
        this.filters.SubCategoriesIds = [];
      }
    },
    documentTypeId: {
      immediate: false,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchYearsFromApi();
          this.fetchCategories();
          this.fetchInstitucionet();
          this.fetchSubCategories();
        }
      },
    },
  },
  async mounted() {
    this.documentStore = useDocumentStore();
    await Promise.all([
      this.fetchYearsFromApi(),
      this.fetchCategories(),
      this.fetchInstitucionet(),
      this.fetchSubCategories(),
    ]);
    if (!this.filters.selectYear && this.availableYears.length > 0) {
      this.filters.selectYear = this.availableYears[0];
    }
    this.fetchDocuments();
  },
  methods: {
    async fetchYearsFromApi() {
      try {
        const response = await this.documentStore.getYears({
          documentTypeId: this.documentTypeId,
        });
        this.availableYears = Array.isArray(response.years)
          ? response.years.sort((a, b) => b - a)
          : [];
        // Zgjidh vitin aktual nëse ekziston, përndryshe vitin më të ri nga lista
        const currentYear = new Date().getFullYear();
        if (this.availableYears.includes(currentYear)) {
          this.filters.selectYear = currentYear;
        } else if (this.availableYears.length > 0) {
          this.filters.selectYear = this.availableYears[0];
        }
        this.$emit('update:availableYears', this.availableYears);
      } catch (error) {
        console.error("Failed to fetch years:", error);
        this.availableYears = [];
        this.$emit('update:availableYears', []);
      }
    },
    async fetchCategories() {
      try {
        const response = await axios.get(`${this.API_URL}${this.documentCategoryURL}`);
        this.filteredCategoryOptions = response.data.map((item) => ({
          id: item.id,
          label: item.title,
        }));
      } catch (error) {
        console.error("Error fetching categories:", error);
        this.filteredCategoryOptions = [];
      }
    },
    async fetchInstitucionet() {
      try {
        const response = await axios.get(`${this.API_URL}${this.documentPostCatgoryUrl}`);
        this.postCategoriesIds = response.data.map((item) => ({
          id: item.id,
          label: item.title,
        }));
      } catch (error) {
        console.error("Error fetching institutions:", error);
        this.postCategoriesIds = [];
      }
    },
    async fetchSubCategories() {
      try {
        const response = await axios.get(`${this.API_URL}${this.documentSubCategoryURL}`);
        this.filteredSubCategoryOptions = response.data.map((item) => ({
          id: item.id,
          label: item.title,
        }));
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        this.filteredSubCategoryOptions = [];
      }
    },
    fetchDocuments() {
      console.log("Emitting filters:", this.filters);
      this.$emit("apply-filters", this.filters);
    },
  },
};
</script>

<style scoped>
/* Style the select to look like a Bootstrap dropdown */
.form-select {
  background-color: transparent;
  border: 1px solid #ced4da;
  box-shadow: none;
  max-height: 200px; /* Limit dropdown height */
  overflow-y: auto;
}

.form-select:focus {
  border-color: #ced4da;
  box-shadow: none;
}

.form-select[multiple] {
  padding: 0.375rem 0.75rem;
}

.form-select[multiple] option {
  padding: 0.25rem 0.5rem;
}

/* Match input-group styling from DocumentPage.vue */
.input-group .form-select {
  background-color: transparent;
}

.input-group .btn-outline-secondary {
  border-color: #ced4da;
}

/* Label styling */
label {
  font-weight: 500;
  margin-bottom: 0.25rem;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .input-group {
    width: 100%;
  }
}

/* Styling for no filters message */
.alert-info {
  margin-top: 1rem;
  text-align: center;
}
</style>